import { IReward } from './IReward';
import { Reward } from './Reward';
import FeeReductionTypes from './FeeReductionTypes';

export class FeeReductionReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.FeeReductionReward';

	public static readonly NAME: string = 'Fee Reduction';

	feeReductionType: string = Object.keys(FeeReductionTypes)[0];

	partialFeeReductionAmount: number | null = null;

	constructor(reward?: IReward) {
	  super(FeeReductionReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.partialFeeReductionAmount = (reward as any).partialFeeReductionAmount;
	    this.feeReductionType = (reward as any).feeReductionType;
	  }
	}

	getDescription(): string {
	  if (FeeReductionTypes[this.feeReductionType] === FeeReductionTypes.FULL_FEE) {
	    return 'Full fee reduction';
	  }
	  return `$${this.partialFeeReductionAmount} fee reduction`;
	}

	clone(): IReward {
	  const clone = new FeeReductionReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default FeeReductionReward;
